var map = {
	"./avi.svg": 320,
	"./default.svg": 321,
	"./doc.svg": 322,
	"./docx.svg": 323,
	"./eml.svg": 324,
	"./exe.svg": 325,
	"./html.svg": 326,
	"./jpeg.svg": 327,
	"./jpg.svg": 328,
	"./mov.svg": 329,
	"./mp4.svg": 330,
	"./pdf-mini.svg": 331,
	"./pdf.svg": 332,
	"./png.svg": 333,
	"./ppt.svg": 334,
	"./pptx.svg": 335,
	"./rar.svg": 336,
	"./txt.svg": 337,
	"./xls.svg": 338,
	"./xlsx.svg": 339,
	"./zip.svg": 340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 210;